import React, { useState } from "react";
import CodeEditor from "./CodeEditor";
import { motion, AnimatePresence } from "framer-motion";

const CodeEditorTabs = ({ files }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const activeFile = files[activeIndex];

  return (
    <div className="border border-black rounded-xl overflow-hidden bg-white font-mono">
      {/* Tab-Leiste */}
      <div className="flex bg-gray-100 border-b border-black">
        {files.map((file, index) => (
          <button
            key={file.filename}
            onClick={() => setActiveIndex(index)}
            className={`px-4 py-2 text-sm transition font-mono ${
              index === activeIndex
                ? "bg-white border-b-2 border-pink-500"
                : "text-gray-600 hover:text-black"
            }`}
          >
            {file.filename}
          </button>
        ))}
      </div>

      {/* Editor-Inhalt mit Animation */}
      <div className="p-4">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeFile.filename}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 20 }}
            transition={{ duration: 0.2 }}
          >
            <CodeEditor
              filename={activeFile.filename}
              language={activeFile.language}
              theme={activeFile.theme}
            >
              {activeFile.code}
            </CodeEditor>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
};

export default CodeEditorTabs;
